import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import logo from './images/logo.jpg';
import './css/App.css';
import showResults from "./showResults";
import DavronForm from "./DavronForm";
import Steps from "react-steps";
import SideCard from "./components/common/sideCard";
import MobileFooter from "./components/common/mobileFooter";
import ErpConnector from "./components/connector/erpnextConnector";
import i18n from './translations/i18n';
import { serviceRequestSelection, shippingAddressFilled, changeLanguage, deleteDoc, samedAddressSelection } from './actions';
import { API_ENDPOINT } from './constants.js';
import { animateScroll } from 'react-scroll';


const mapStateToProps = (state) => ({
	price: state.globals.price,
	coupon: state.globals.coupon,
	items: state.globals.items,
	qty: state.globals.qty,
	codes: state.globals.codes,
	files: state.globals.files,
	uploadedFiles: state.globals.files,
	lng: state.globals.lang,
	currency: state.form.davron === undefined ? "EUR": state.form.davron.values.currency,
	service: state.form.davron === undefined ? "translation": state.form.davron.values.service,
	priceRefresh: state.globals.priceRefresh,
	davronForm: state.form.davron,
	shippingCountry: state.form.davron === undefined ? "France": state.form.davron.values.shippingCountry,
	billingCountry: state.form.davron === undefined ? "France": state.form.davron.values.billingCountry,
	deadline: state.form.davron === undefined ? "5BusinessDays" : state.form.davron.values.deadline,
	user: (state.form.davron === undefined || state.form.davron.values.user === undefined) ? "Guest" : state.form.davron.values.user
})

const mapDispatchToProps = (dispatch) => ({
	serviceRequestClick: (value) => dispatch(serviceRequestSelection(value)),
	shippingAddressChange: (value) => dispatch(shippingAddressFilled(value)),
	setInitialValue: (form, name, value) => dispatch(change(form, name, value)),
	setLang: (value) => dispatch(changeLanguage(value)),
	deleteDocument: (value) => dispatch(deleteDoc(value)),
	sameAddressChange: (value) =>dispatch(samedAddressSelection(value))
})

class App extends Component {
	constructor(props) {
		super(props)

		const urlParams = new URLSearchParams(window.location.search)
		const urlPathname = window.location.pathname.replace("/", "")

		this.state = {
			page: 1,
			lng: urlParams.get("lang") || ["fr", "en"].includes(urlPathname) ? urlPathname : null || 'en',
			certifications: [],
			coaching_lang: [],
			countries: [],
			courier_services: [],
			durations: [],
			from_lang: [],
			to_lang: [],
			interpreting_purposes: [],
			interpreting_types: [],
			levels: [],
			number_of_hours: [],
			official_documents: [],
			source_available: [],
			specialty_fields: [],
			shipping_fees: [],
			translation_requestors: [],
			opportunity: "9999",
			files_added: true,
			mainTitle: null,
			mainSubtitle: null,
			mainSubtitle1: null,
			mainSubtitle2: null
		}
		this.nextPage = this.nextPage.bind(this);
		this.previousPage = this.previousPage.bind(this);
		this.setFrench = this.setFrench.bind(this);
		this.setEnglish = this.setEnglish.bind(this);
		this.deliveryPrice = this.deliveryPrice.bind(this);
		this.getInitialValues = this.getInitialValues.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.reloadForm = this.reloadForm.bind(this);
		this.initValues = this.initValues.bind(this);
		this.deleteDocs = this.deleteDocs.bind(this);
	}

	componentDidMount() {
		this.initValues();
		window.gtag('event', 'page_view')
	}

	initValues() {
		this.setTitles();
		this.getInitialValues();
	}

	getInitialValues() {
		const url = API_ENDPOINT + "/api/method/davrontranslations.davrontranslations.api.initialize_data"
		const header = new Headers()
		header.append('Content-Type', 'application/json');
		const options = {
			method: 'POST',
			body: JSON.stringify({data: {lang: this.state.lng}}),
			headers: header
		}
		this.props.setLang(this.state.lng);
		return fetch(url, options)
		.then(result => {
			return result.json();
		})
		.then(data => {
			const d = data.message;

			this.setState({
				certifications: d.certifications,
				coaching_lang: d.coaching_lang,
				countries: d.countries,
				courier_services: d.courier_services,
				durations: d.durations,
				from_lang: d.from_lang,
				to_lang: d.to_lang,
				interpreting_purposes: d.interpreting_purposes,
				interpreting_types: d.interpreting_types,
				levels: d.levels,
				number_of_hours: d.number_of_hours,
				official_documents: d.official_documents,
				source_available: d.source_available,
				specialty_fields: d.specialty_fields,
				shipping_fees: d.shipping_fees,
				translation_requestors: d.translation_requestors,
				administration_fees: d.administration_fees
			})

			// Set initial values explicitely
			const form = 'davron';
			this.props.setInitialValue(form, 'sourceLanguage', d.from_lang[0]);
			this.props.setInitialValue(form, 'targetLanguage', d.to_lang[1]);
		})
		.catch(error => {
			this.setState({ page: 0 }, () => {
				this.setTitles()
			});
		})
	}

	handleSubmit(values) {
		const url = API_ENDPOINT + "/api/method/davrontranslations.davrontranslations.api.submit_form"
		const header = new Headers()
		header.append('Content-Type', 'application/json');

		values['qty'] = this.props.qty;
		values['files'] = this.props.files;
		values['codes'] = this.props.codes;
		values['lang'] = this.props.lng;

		const options = {
			method: 'POST',
			body: JSON.stringify({data: values}),
			headers: header
		}
		return fetch(url, options)
		.then(result => {
			return result.json();
		})
		.then(data => {
			if (data.message&&data.message.status==="success") {
				this.setState({
					page: 5,
					opportunity: data.message.opportunity !== undefined ? data.message.opportunity : "9999"
				})
			} else {
				this.setState({
					page: 5
				})
			}

			const {vat, totalPrice} = this.calculatePrice()
			window.gtag('event', 'purchase', {
				'transaction_id': (data.message && data.message.opportunity !== undefined) ? data.message.opportunity : "9999",
				'value': totalPrice,
				'currency': values['currency'],
				'tax': vat,
				'event_label': 'Form Submission'
			});
			window.gtag_report_conversion()
			
		})
	}

	reloadForm() {
		window.location.reload();
	}

	nextPage(values) {
		if (this.state.page === 2 && (values.service === "translation" || values.service === "official")) {
			if (!values.fileSection || Object.keys(values.fileSection).length === 0) {
				this.setState({files_added: false});
				return;
			} else {
				this.setState({files_added: true});
			}
		}
		animateScroll.scrollToTop();
		let me = this;
		if (this.state.page === 2 && this.props.service === "translation" && !this.props.davronForm.values.desktopPublishing) {
			if (this.props.uploadedFiles.some(file => (!["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword"].includes(file.mimetype)))) {
				me.props.setInitialValue('davron', 'desktopPublishing', true);
			}
		}
		this.setState({
			page: this.state.page + 1
		}, () => {
				this.setTitles()
		});
	}

	previousPage() {
		animateScroll.scrollToTop();
		this.setState({
			page: this.state.page - 1
		}, () => {
				this.setTitles()
		});
	}

	setTitles() {
		let service = this.props.service;
		if (this.state.page===1) {
			this.setState({
				mainTitle: i18n.t(`app.page_1_title`, {lng: this.state.lng}),
				mainSubtitle: i18n.t(`app.page_1_subtitle`, {lng: this.state.lng})
			});
		} else if (this.state.page===2){
			this.setState({ mainTitle: i18n.t(`app.page_2_title`, {lng: this.state.lng}),
							mainSubtitle: null
			});
		} else if (this.state.page===3){
			this.setState({ mainTitle:i18n.t(`app.page_3_${service}_title`, {lng: this.state.lng}),
							mainSubtitle: null
			});
			if (service === "translation") {
				this.setState({ mainSubtitle: i18n.t(`app.page_3_${service}_subtitle`, {lng: this.state.lng}) });
			}
		} else if (this.state.page===4){
			this.setState({
				mainTitle: i18n.t(`app.page_4_title`, {lng: this.state.lng}),
				mainSubtitle: i18n.t(`app.page_4_subtitle`, {lng: this.state.lng}),
				mainSubtitle1: i18n.t(`app.page_4_subtitle1`, {lng: this.state.lng})
			});
		} else if (this.state.page===5){
			this.setState({ mainTitle: i18n.t(`app.page_5_title`, {lng: this.state.lng}),
							mainSubtitle: null
			});
		} else if (this.state.page===0){
			this.setState({ mainTitle: i18n.t(`app.page_0_title`, {lng: this.state.lng}),
							mainSubtitle: null
			});
		}
	}

	setFrench() {
		this.props.setLang('fr');
		this.setState({
			lng: 'fr'
		}, () => {
			this.initValues()
			this.deleteDocs()
		});
	}

	setEnglish() {
		this.props.setLang('en');
		this.setState({
			lng: 'en'
		}, () => {
			this.initValues()
			this.deleteDocs()
		});
	}

	deleteDocs() {
		this.props.files.forEach((v) => {
			this.props.deleteDocument(v.handle);
		})
	}

	deliveryPrice(form) {
		if (form !== undefined) {
			let fields = ['courierServiceDelivery', 'registeredLetterDelivery', 'trackedLetterDelivery'];
			let fieldmap = {'courierServiceDelivery': 'Courier Service', 'registeredLetterDelivery': 'Registered Letter', 'trackedLetterDelivery': 'Tracked Letter'}
			let shipping_country = this.props.shippingCountry === 'France' ? 'France' : (this.props.shippingCountry === 'United Kingdom' ? 'United Kingdom' : 'United States');
			let currency = this.props.currency;
			let deliveryService = 'emailServiceDelivery';
			fields.forEach(value => {
				if (form.values[value] === true) {
					deliveryService = value;
				}
			});

			if (deliveryService==='courierServiceDelivery' && form.values.courierOption==="Hand-delivery in Paris") {
				return 0;
			}

			let method = fieldmap[deliveryService];
			if (deliveryService !== 'emailServiceDelivery' && method !== undefined && this.state.shipping_fees.length > 0) {
				let entries = Object.entries(this.state.shipping_fees).filter(([k,v]) => (v.country===shipping_country&&v.method===method&&v.currency===currency));
				if (entries.length > 0) {
					let filtered = Object.assign(...entries);
					return filtered[1].price;
				} else {
					return 0;
				}
				
			} else {
				return 0;
			}
		}
	}

	calculatePrice() {
		let vat = 0, deliveryPrice = 0, deadlinePrice = 0, totalPrice=0, calculatedPrice=0, mobilePrice=0, price=0, coupon=0, transactionFee=0;
		let vatDisplay = false;

		const deadlines = {
			"5BusinessDays": {"factor": 0, "name": i18n.t('sidecard.5BusinessDays', {lng: this.state.lng})}, 
			"12hDeadline": {"factor": 1.5, "name": i18n.t('sidecard.12hDeadline', {lng: this.state.lng})}, 
			"24hDeadline": {"factor": 1, "name": i18n.t('sidecard.24hDeadline', {lng: this.state.lng})}, 
			"48hDeadline": {"factor": 0.5, "name": i18n.t('sidecard.48hDeadline', {lng: this.state.lng})},
			"upto2weeks": {"factor": -0.05, "name": i18n.t('sidecard.upto2weeks', {lng: this.state.lng})}
		}

		let urgencyName = this.props.davronForm ? deadlines[this.props.davronForm.values.deadline]["name"] : "";
		let urgencyFactor = this.props.davronForm ? deadlines[this.props.davronForm.values.deadline]["factor"] : 0;

		if (this.props.davronForm !== undefined) {
			if (this.props.price!=="Unavailable") {

				if (this.props.coupon&&this.props.coupon.discount_percentage) {
					price = Math.floor(this.props.price * (1 - this.props.coupon.discount_percentage / 100))
					coupon = Math.floor(this.props.price * (this.props.coupon.discount_percentage / 100))
				} else {
					price = this.props.price
				}

				if (["translation", "official"].includes(this.props.davronForm.values.service)) {
					if (!(this.props.davronForm.values.service === "translation" && !this.props.davronForm.values.certification)) {
						deliveryPrice = this.deliveryPrice(this.props.davronForm);
					}
					deadlinePrice = price * urgencyFactor;
					const fileSection = this.props.davronForm.values.fileSection || {}
					const page_number = Object.keys(fileSection).map(f => fileSection[f].pages).reduce((target, source) => parseInt(source, 10) + target, 0)
					transactionFee = (this.state.administration_fees[this.props.currency] || 0) * page_number;
				}

				if (this.state.page>=4&&this.props.davronForm.values.billingCountry==="France"&&!this.props.davronForm.values.vatNumber) {
					vat = ((price + deliveryPrice + deadlinePrice + transactionFee) * 20/100);
					vatDisplay = true;
				}

				totalPrice = Math.floor((price + vat + transactionFee + deliveryPrice + deadlinePrice) * 100) / 100;
				deliveryPrice = Math.floor(deliveryPrice * 100) / 100;
				deadlinePrice = Math.floor(deadlinePrice * 100) / 100;
				vat = Math.floor(vat * 100) / 100;
				calculatedPrice = Math.floor(this.props.price * 100) / 100;
				mobilePrice = calculatedPrice + deliveryPrice + deadlinePrice
			}
		}

		return {totalPrice, deliveryPrice, deadlinePrice, vat, calculatedPrice, vatDisplay, urgencyFactor, urgencyName, mobilePrice, coupon, transactionFee}
	}

	render() {
		const lng = this.state.lng;
		let data = [
			{
				"text": i18n.t(`app.step_1_title`, {lng: this.state.lng}),
				"isActive": (this.state.page===1 ? true : false),
				"isDone": (this.state.page>1 ? true : false)
			},
			{
				"text": i18n.t(`app.step_2_title`, {lng: this.state.lng}),
				"isActive": (this.state.page===2 ? true : false),
				"isDone": (this.state.page>2 ? true : false)
			},
			{
				"text": i18n.t(`app.step_3_title`, {lng: this.state.lng}),
				"isActive": (this.state.page===3 ? true : false),
				"isDone": (this.state.page>3 ? true : false)
			},
			{
				"text": i18n.t(`app.step_4_title`, {lng: this.state.lng}),
				"isActive": (this.state.page===4 ? true : false),
				"isDone": (this.state.page>4 ? true : false)
			}
		];
		let stepStyles = {
				doneFlatItem: {background: "#0D3680", borderRadius: "1px", textShadow: "none", marginRight: "2px", marginLeft: "1px"},
				activeFlatItem: {background: "#ff8034", borderRadius: "1px", textShadow: "none", marginRight: "2px", marginLeft: "1px"},
				itemFlat: {background: "#9b9b9b", borderRadius: "1px", textShadow: "none", marginRight: "2px", marginLeft: "1px"}
		}

		const {totalPrice, deliveryPrice, deadlinePrice, vat, calculatedPrice, vatDisplay, urgencyFactor, urgencyName, mobilePrice, coupon, transactionFee} = this.calculatePrice()
		return (
			<div>
				<nav className="navbar navbar-expand-lg navbar-light">
					<div className="container">
						<a className="navbar-brand" href="https://davrontranslations.com" alt="Davron Translations Website"><img className="logo" src={logo} alt="davron-logo"></img></a>
						<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className="collapse navbar-collapse" id="navbarSupportedContent">
						<ul className="navbar-nav ml-auto">
							<ErpConnector lng={lng}/>
							<li className="nav-item dropdown">
								<a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									{i18n.t('app.language', {lng})}
								</a>
								<div className="dropdown-menu" aria-labelledby="navbarDropdown">
									<a className="dropdown-item lng-btn" onClick={this.setFrench}>{i18n.t('app.french', {lng})}</a>
									<a className="dropdown-item lng-btn" onClick={this.setEnglish}>{i18n.t('app.english', {lng})}</a>
								</div>
							</li>
						</ul>
						</div>
					</div>
				</nav>
				<section className="text-center sticky-top grey-bckg pt-2 pb-4">
					<div className="container">
					<div className="d-none d-sm-block col-md-12 col-lg-8">
						<Steps
							lng={lng}
							items={data} 
							flat={true}
							styles={stepStyles}
							page={this.state.page}
							/>
						</div>
						</div>
				</section>
				<div id="main">
					<div className="container" >
						<div className="page-content">
							<section className="card-section">
								<div className="row">
								<div className="col-12 col-lg-8 mb-5">
									<div className="card">
										<div className="card-body">
											<div className="title title-border title-border text-left">
												<h2 className="main-title">{this.state.mainTitle}</h2>
											</div>
											<p className="small tooltip-text">{this.state.mainSubtitle}<br></br>{this.state.mainSubtitle1}<br></br>{this.state.mainSubtitle2}</p>
											<div className="card-content">
												<DavronForm
													lng={lng}
													showResults={showResults}
													onSubmit={this.handleSubmit}
													page={this.state.page}
													nextPage={this.nextPage}
													previousPage={this.previousPage}
													formState={this.state}
													serviceRequestClick={this.props.serviceRequestClick}
													shippingCountry={this.props.shippingCountry}
													currency={this.props.currency}
													uploadedFiles = {this.props.uploadedFiles}
													shippingAddressChange={this.props.shippingAddressChange}
													opportunity={this.state.opportunity}
													filesAdded={this.state.files_added}
													reloadForm={this.reloadForm}
													sameAddressChange={this.props.sameAddressChange}
													coupon={coupon}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="d-none d-sm-block col-sm-12 col-lg-4 mb-5">
									<div className="sticky-top side-card card">
										<div className="card-body">
											<div className="card-content">
												<div className="page-card">
													<SideCard
														lng={lng}
														page={this.state.page}
														price={this.props.price}
														currency={this.props.currency}
														items={this.props.items}
														qty={this.props.qty}
														priceRefresh={this.props.priceRefresh}
														form={this.props.davronForm}
														urgencyName={urgencyName}
														urgencyFactor={urgencyFactor}
														vat={vat}
														transactionFee={transactionFee}
														deliveryPrice={deliveryPrice}
														deadlinePrice={deadlinePrice}
														totalPrice={totalPrice}
														calculatedPrice={calculatedPrice}
														vatDisplay={vatDisplay}
														coupon={coupon}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
									<footer className="d-sm-none footer">
										<div className="container">
											<MobileFooter 
												lng={lng}
												price={this.props.price}
												currency={this.props.currency}
												items={this.props.items}
												priceRefresh={this.props.priceRefresh}
												form={this.props.davronForm}
												billingCountry={this.props.billingCountry}
												page={this.state.page}
												service={this.props.service}
												totalPrice={totalPrice}
												calculatedPrice={mobilePrice}
											/>
										</div>
									</footer>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default App = connect( mapStateToProps, mapDispatchToProps )(App)


// WEBPACK FOOTER //
// ./src/App.js